import { render, staticRenderFns } from "./ContactsListCommunication.vue?vue&type=template&id=b3758ab0&scoped=true&"
import script from "./ContactsListCommunication.vue?vue&type=script&lang=js&"
export * from "./ContactsListCommunication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3758ab0",
  null
  
)

export default component.exports